module.exports = __webpack_public_path__ + "img/POSASSISTANT_APP_Android.069a1bac.png";